var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-layout',{attrs:{"suite":"worksends","menu-links":_vm.mainMenuLinks,"bottom-menu-links":_vm.bottomMenuLinks}})
}
var staticRenderFns = []

export { render, staticRenderFns }